import { z } from 'zod'
import {
  checkIsLowercase,
  eventDataSchema,
  filterDataSchema,
  refinementWithMessage,
  resultsDataSchema,
  zodResultsDataInputTypeEnum,
  zodString,
} from '../../common.schema'

export const SearchSchema = z.object({
  event: z.literal('search'),

  event_data: eventDataSchema,
  results_data: resultsDataSchema.extend({
    input_type: zodResultsDataInputTypeEnum.or(
      z.enum([
        'nba',
        'gallery',
        'quick filters',
        'filters menu',
        'filter',
        'entry point banner',
        'reminder prompt',
        'rude toggle within grid',
        'guided nbas',
      ]),
    ),
    results_list: zodString.refine(
      checkIsLowercase,
      refinementWithMessage('Value must be lowercase.'),
    ),
    redirected_from: zodString.optional(),
  }),
  filter_data: filterDataSchema,
})

export type SearchEvent = z.infer<typeof SearchSchema>
